<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu đi muộn</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Tiêu đề"
                          prop="employee_request.title"
                        >
                          <el-input
                            type="text"
                            v-model="mData.dataForm.employee_request.title"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            ref="title"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Phân loại"
                          prop="employee_request.type"
                        >
                          <el-select
                            disabled
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="mData.reselectEmployee">
                        <el-form-item
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employee_id
                            "
                            :disabled="!isSelectEmployee"
                            @change="fn_reSelectEmployee"
                          >
                            <el-option
                              v-for="item in filteredRequestEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select v-model="requestEmployeeFilter.branch_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả chi nhánh" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredBranchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select v-model="requestEmployeeFilter.department_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả phòng ban" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredDepartmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý trực tiếp"
                          prop="employee_request.level2Approval"
                        >
                          <DirectManagerField
                            v-model="
                              mData.dataForm.employee_request.level2Approval
                            "
                            :options="mData.dataDefault.listQuanLyTrucTiep"
                            :label-builder="fn_setLabelRespectively"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employeeApproval
                            "
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ?`${item.e.employee_no ? item.e.employee_no : ''} - ${item.e.administrative_info.name.full_name ? item.e.administrative_info.name.full_name : ''}`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Lý do"
                          prop="detail_request.request_reason_id"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.detail_request.request_reason_id
                            "
                          >
                            <el-option
                              v-for="item in mData.dataDefault
                                .listRequestReason"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="listEmployeeShiftDetail.length > 0">
                        <el-form-item
                          label="Ca làm việc"
                          prop="detail_request.shift_id"
                        >
                          <el-radio-group
                            v-model="mData.dataForm.detail_request.shift_id"
                            @change="fn_changeShift"
                          >
                            <el-radio
                              class="mr-3"
                              v-for="(shift, index) in listEmployeeShiftDetail"
                              :key="index"
                              :label="shift.id"
                              >{{ shift.name }}</el-radio
                            >
                          </el-radio-group>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Thời gian đi muộn"
                          prop="detail_request.extra_minute"
                        >
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.extra_minute"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'HH:mm dd/MM/yyyy' || 'HH:mm dd-MM-yyyy'"
                            :picker-options="pickerOptionFrom"
                            @change="fn_checkValidDate"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ghi chú"
                          prop="employee_request.content"
                        >
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        :disabled="!createRequest"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestGoLateApi from "../../../../moduleApi/EmployeeRequestGoLateApi";
import DirectManagerField from "../components/DirectManagerField";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  components: { DirectManagerField },
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      typeReq: "GO_LATE",
    };
  },
  computed: {
    filteredDepartmentList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listDepartment || []).filter(
          (dept) => dept.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const departmentIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listDepartment || []).filter((dept) =>
        departmentIds.includes(dept.id)
      );
    },
    filteredBranchList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listBranch || []).filter(
          (branch) => branch.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const branchIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listBranch || []).filter((branch) =>
        branchIds.includes(branch.id)
      );
    },
  },
  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListEmployeeRequestReason(this.typeReq);
      await this.fn_getListEmployeeApprovedQLTT();
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return;
      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      if (!selectedEmployee) return;

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee);
      this.requestEmployeeFilter.department_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];
      this.requestEmployeeFilter.branch_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut();
      });
    },

    async fn_reSelectEmployee() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        return;
      }

      this.fn_syncRequestOrgFilterByEmployee(
        this.mData.dataForm.employee_request.employee_id
      );
      await this.fn_initDataShift();
      this.mData.validForm.employee_request.employee_id = [];
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("employee_request.employee_id");
        }
      });
    },

    fn_checkValidDate() {
      this.createRequest = true;
      const goLateTime =
        new Date(this.mData.dataForm.detail_request.extra_minute).getTime();
      if (!this.mData.dataForm.employee_request.employee_id) {
        window.toastr.warning("Vui lòng chọn Nhân viên !");
        this.mData.dataForm.detail_request.extra_minute = undefined;
      } else if (!this.mData.dataForm.detail_request.shift_id) {
        window.toastr.warning("Vui lòng chọn Ca làm việc trước khi chọn thời gian !");
        this.mData.dataForm.detail_request.extra_minute = undefined;
      } else if (this.listEmployeeShift) {
        // Check shift validity against the selected time, including past dates.
        const validShift = this.fn_checkValidShift(goLateTime);
        const idEmployeeShift = validShift && validShift.shift_id;
        // Check whether the selected time falls within the shift acceptance window.
        if (idEmployeeShift) {
          this.validTimeCreateReq = false;
          const t = this.mData.dataForm.detail_request.extra_minute;
          let todayShiftTime = [];
          const flag = this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
          if (flag) {
            this.fn_checkValidTimeReq(todayShiftTime, t, idEmployeeShift, goLateTime);
            if (this.validTimeCreateReq == false) {
              this.createRequest = false;
              window.toastr.warning(
                "Thời gian xin đi muộn phải trong khoảng từ khi bắt đầu đến khi kết thúc ca!"
              );
            }
          }
        } else {
          this.mData.dataForm.detail_request.extra_minute = undefined;
          window.toastr.warning(
            "Ca này không hiệu lực tại thời điểm được chọn để tạo yêu cầu !"
          );
        }
      } else {
        this.createRequest = false;
        window.toastr.warning("Nhân viên không có ca để tạo yêu cầu !");
      }
    },

    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.level2Approval,
              },
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.title =
              this.mData.dataForm.employee_request.title.trim();
            this.mData.dataForm.employee_request.content =
              this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id =
              this.currentCompany.id;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 2;
            this.mData.dataForm.employee_request.approval_users =
              listApprovalUser;
            let dataEmployeeRequest = this.mData.dataForm.employee_request;
            let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;
            if (type == "create") {
              const res = await EmployeeRequestApi.create(dataEmployeeRequest);
              dataEmployeeRequestDetail.id = res.result;
              await EmployeeRequestGoLateApi.create(dataEmployeeRequestDetail);
              if (
                this.mData.dataDefault.listFeature.includes("FT1001") ||
                this.mData.dataDefault.listFeature.includes("FT1002")
              ) {
                this.$router.push({
                  name: "Admin-ManageRequests-RequestsWaitingForApproval",
                });
              }
              this.fn_resetForm();
              this.listEmployeeShiftDetail = [];
              this.fn_checkHasEmployeeQTLL();
            }
          } catch (error) {
            console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },

  async created() {
    this.mData.dataForm.employee_request.type = "GO_LATE";
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployeeQTLL();
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css"></style>
